import { ApprovalType, getApproval } from "src/components/survey/SurveyFormModel";
import { DisplayLabels, Model, Pair } from "src/components/survey/ApplicationIdentity/model/utils";
import { StyledSpan } from "src/components/ApprovalStatuses/utils";
import React from "react";

export function approvedBy(model: Model): Pair {
    const alias = getApproval(model.application, ApprovalType.PrivacyApproval).approverAlias;
    return {
        label: DisplayLabels.ApprovedBy,
        value: alias.trim() === "" ? <StyledSpan>&mdash;</StyledSpan> : alias,
    };
}
